import {
	ClockOutline,
	CoinPointsOutline,
	DocumentTextOutline,
	LightBulbOutline,
	rem,
	SmileyFaceOutline,
	SparklesOutline,
	SpeakerphoneOutline,
} from '@bonusly/design-system';

import { Notification, NotificationType } from '../../../lib/notification/notification';
import { UserProfile } from '../../../types/user';
import { IconChip } from '../../Chip';
import { UserAvatar } from '../../User';

interface UseGetIconProps {
	notification: Notification;
}

export const useGetIcon = ({ notification }: UseGetIconProps) => {
	switch (notification.type) {
		case NotificationType.NewBonus:
		case NotificationType.BonusAddOn:
		case NotificationType.BonusCommentForOtherCommenter:
		case NotificationType.BonusCommentForCC:
		case NotificationType.BonusCommentForGiver:
		case NotificationType.BonusCommentForReceiver:
		case NotificationType.NewBonusForCC:
		case NotificationType.ConstructiveFeedbackRequest:
		case NotificationType.ConstructiveFeedbackResponse:
		case NotificationType.ConstructiveFeedbackMessage:
		case NotificationType.ConstructiveFeedbackResent:
		case NotificationType.ConstructiveFeedbackReportReceived:
		case NotificationType.ConstructiveFeedbackRequestExpiring:
		case NotificationType.ConstructiveFeedbackUnrequestedFeedback:
		case NotificationType.ConstructiveFeedbackUnrequestedFeedbackReceiverAddedMessage:
		case NotificationType.ConstructiveFeedbackUnrequestedFeedbackGiverAddedMessage:
		case NotificationType.OneOnOneNewMeeting:
			return (
				<UserAvatar
					border="none"
					boxSize={rem(44)}
					cursor="pointer"
					size="lg"
					user={
						(notification.avatar as UserProfile) ?? {
							display_name: '',
							profile_pic_url: '',
						}
					}
				/>
			);
		case NotificationType.NewMonth:
			return (
				<IconChip colorScheme="blue">
					<CoinPointsOutline />
				</IconChip>
			);
		case NotificationType.EndOfMonth:
			return (
				<IconChip colorScheme="red">
					<ClockOutline />
				</IconChip>
			);
		case NotificationType.ReviewGeneratedByManager:
			return (
				<IconChip colorScheme="lightBlue">
					<DocumentTextOutline />
				</IconChip>
			);
		case NotificationType.ReviewRecordReady:
			return (
				<IconChip colorScheme="lightBlue">
					<DocumentTextOutline />
				</IconChip>
			);
		case NotificationType.ReviewTemplatePublished:
			return (
				<IconChip colorScheme="purple">
					<SpeakerphoneOutline />
				</IconChip>
			);
		case NotificationType.UpcomingReviewDate:
			return (
				<IconChip colorScheme="yellow">
					<LightBulbOutline />
				</IconChip>
			);
		case NotificationType.BillingPlanChange:
			return (
				<IconChip colorScheme="purple">
					<SpeakerphoneOutline />
				</IconChip>
			);
		case NotificationType.WarmUpNonGiver:
			return (
				<IconChip colorScheme="yellow">
					<LightBulbOutline />
				</IconChip>
			);
		case NotificationType.OneOnOneMeetingUpcomingDirectReport:
		case NotificationType.OneOnOneMeetingUpcomingManager:
			return (
				<IconChip colorScheme="red">
					<ClockOutline />
				</IconChip>
			);
		case NotificationType.NominationsEndDate:
			return (
				<IconChip colorScheme="purple">
					<SpeakerphoneOutline />
				</IconChip>
			);
		case NotificationType.NominationsStartDate:
		case NotificationType.Announcement:
			return (
				<IconChip colorScheme="purple">
					<SpeakerphoneOutline />
				</IconChip>
			);
		case NotificationType.AdminCheckInSummary:
			return (
				<IconChip colorScheme="lightGreen">
					<SmileyFaceOutline />
				</IconChip>
			);
		case NotificationType.EmployeeSpotlightRead:
			return (
				<IconChip colorScheme="yellow">
					<SparklesOutline />
				</IconChip>
			);
	}
};
